import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/pages/HelloWorld'
Vue.use(Router);
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};
const VueRouterReplace = Router.prototype.replace;
Router.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch((err) => err);
};

let vuerouter = new Router({
  mode: "history", //去掉#号
  routes: [
    // 登录
    {
      path: "/",
      name: "login",
      component: (resolve) => require(["../pages/login/index.vue"], resolve),
    },
    {
      path: "/root",
      component: (resolve) => require(["../pages/Root/root.vue"], resolve),
      children: [
        {
          path: "/user",
          meta: { title: "个人中心" },
          component: (resolve) => require(["../pages/home/user.vue"], resolve),
        },
        // {
        //   path: "/XuiGaiMiMa",
        //   component: (resolve) =>
        //     require(["../pages/login/XuiGaiMiMa.vue"], resolve),
        // },
        // 首页 大数据
        {
          path: "/home",
          meta: { title: "首页" },
          component: (resolve) => require(["../pages/home/index.vue"], resolve),
        },
        {
          path: "/user_list",
          meta: { title: "账户管理" },
          component: (resolve) =>
            require(["../pages/views/user/list.vue"], resolve),
        },
        {
          path: "/role_list",
          meta: { title: "角色管理" },
          component: (resolve) =>
            require(["../pages/views/role/list.vue"], resolve),
        },
        {
          path: "/transaction_list",
          meta: { title: "大额收单" },
          component: (resolve) =>
            require(["../pages/views/transaction/list.vue"], resolve),
        },
        {
          path: "/import_list",
          meta: { title: "录入订单" },
          component: (resolve) =>
            require(["../pages/views/import/list.vue"], resolve),
        },
        {
          path: "/transfer_list",
          meta: { title: "代付管理" },
          component: (resolve) =>
            require(["../pages/views/transfer/list.vue"], resolve),
        },
        {
          path: "/transfer_create",
          meta: { title: "录入付款信息", father: "/transfer_list" },
          component: (resolve) =>
            require(["../pages/views/transfer/create.vue"], resolve),
        },
        {
          path: "/account_list",
          meta: { title: "提现管理" },
          component: (resolve) =>
            require(["../pages/views/account/list.vue"], resolve),
        },
        {
          path: "/splittings_list",
          meta: { title: "分账管理" },
          component: (resolve) =>
            require(["../pages/views/splittings/list.vue"], resolve),
        },
      ],
    },
  ],
});
vuerouter.beforeEach((to, from, next) => {
  let url = next();
  if (to.name != "login" && !window.localStorage.getItem("$JHToken")) {
    url = next("/");
  }
  return url;
});
export default vuerouter;



// WEBPACK FOOTER //
// ./src/router/index.js